/* eslint-disable */

export const LANG_PL = 'pl';
export const LANG_EN = 'en';
export const LANG_DE = 'de';
export const AVAILABLE_LANGUAGES = eval(process.env.AVAILABLE_LANGUAGES);



// WEBPACK FOOTER //
// ./src/config/languages.js